module.exports = __webpack_public_path__ + "static/footer-330981569c3b26ec808f0d238d5ed60e.png";